var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      attrs: { show: _vm.show },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Orden de Compra" },
          on: { cerrar: _vm.closeModal }
        },
        [
          _c(
            "div",
            {
              staticClass: "numero_sim",
              staticStyle: {
                "letter-spacing": "0.02em",
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "margin-top": "16px"
              }
            },
            [
              !_vm.deshabilitado
                ? _c(
                    "div",
                    {
                      staticClass: "boton_crear",
                      staticStyle: { height: "37px" }
                    },
                    [
                      _vm.id_orden_compra == null
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "icon",
                              staticStyle: {
                                "background-color": "#ff6c00 !important",
                                "border-color": "#ff6c00 !important",
                                "padding-right": "20px",
                                display: "block",
                                margin: "0 0 0 auto"
                              },
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.validarGrilla()
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "color-blanco",
                                  staticStyle: { color: "white" }
                                },
                                [_vm._v("GUARDAR")]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.id_orden_compra != null
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "icon",
                              staticStyle: {
                                "background-color": "#ff6c00 !important",
                                "border-color": "#ff6c00 !important",
                                "padding-right": "20px",
                                display: "block",
                                margin: "0 0 0 auto"
                              },
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.editar()
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "color-blanco",
                                  staticStyle: { color: "white" }
                                },
                                [_vm._v("GUARDAR CAMBIOS")]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _c(
        "v-card",
        { staticClass: "modalCrearOC", attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Información General")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "orden_compra", attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _vm.id_orden_compra != null
                                ? _c("h1", [
                                    _vm._v(
                                      "\n                Editar Orden de Compra: " +
                                        _vm._s(_vm.id_orden_compra) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e(),
                              _vm.id_orden_compra == null
                                ? _c("h1", [_vm._v("Crear Orden de Compra")])
                                : _vm._e(),
                              _c(
                                "FormFieldsContainer",
                                { attrs: { "mb-3": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "prepend-icon": "123",
                                          color: "primary",
                                          label: "Compra Número",
                                          disabled: ""
                                        },
                                        model: {
                                          value: _vm.valor_id_orden_compra,
                                          callback: function($$v) {
                                            _vm.valor_id_orden_compra = $$v
                                          },
                                          expression: "valor_id_orden_compra"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          "prepend-icon": "description",
                                          color: "primary",
                                          label: "Descripción (Requerido)",
                                          disabled: _vm.deshabilitado
                                        },
                                        model: {
                                          value: _vm.descrip,
                                          callback: function($$v) {
                                            _vm.descrip = $$v
                                          },
                                          expression: "descrip"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          locale: "es-cl",
                                          color: "primary",
                                          label: "Fecha emisión",
                                          disabled: ""
                                        },
                                        model: {
                                          value: _vm.fecha_alta,
                                          callback: function($$v) {
                                            _vm.fecha_alta = $$v
                                          },
                                          expression: "fecha_alta"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          locale: "es-cl",
                                          color: "primary",
                                          label: "Fecha Llegada ",
                                          disabled:
                                            _vm.id_orden_compra == null ||
                                            _vm.deshabilitado
                                        },
                                        model: {
                                          value: _vm.fecha_llegada,
                                          callback: function($$v) {
                                            _vm.fecha_llegada = $$v
                                          },
                                          expression: "fecha_llegada"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          "prepend-icon": "person",
                                          color: "primary",
                                          label: "Cuenta Costo (Requerido)",
                                          type: "number",
                                          disabled: _vm.deshabilitado
                                        },
                                        model: {
                                          value: _vm.rut_contable,
                                          callback: function($$v) {
                                            _vm.rut_contable = $$v
                                          },
                                          expression: "rut_contable"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          "item-text": "proveedorrazon",
                                          items: _vm.lista_proveedores,
                                          "item-value": "proveedorrut",
                                          label:
                                            "Razón Social Proveedor (Requerido)",
                                          "prepend-icon": "supervisor_account",
                                          disabled: _vm.deshabilitado
                                        },
                                        on: {
                                          change: _vm.handleProveedorChange
                                        },
                                        model: {
                                          value: _vm.rut_proveedor,
                                          callback: function($$v) {
                                            _vm.rut_proveedor = $$v
                                          },
                                          expression: "rut_proveedor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          "item-text": "configvalor",
                                          items: _vm.lista_estados,
                                          "item-value": "configid",
                                          label: "Estado (Requerido)",
                                          "prepend-icon": "book",
                                          disabled: _vm.deshabilitado
                                        },
                                        model: {
                                          value: _vm.estado,
                                          callback: function($$v) {
                                            _vm.estado = $$v
                                          },
                                          expression: "estado"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Observación",
                                          "prepend-icon": "search",
                                          disabled: _vm.deshabilitado
                                        },
                                        model: {
                                          value: _vm.observacion,
                                          callback: function($$v) {
                                            _vm.observacion = $$v
                                          },
                                          expression: "observacion"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Solicitado Por",
                                          "prepend-icon": "badge",
                                          disabled: _vm.deshabilitado
                                        },
                                        model: {
                                          value: _vm.solicitadoPor,
                                          callback: function($$v) {
                                            _vm.solicitadoPor = $$v
                                          },
                                          expression: "solicitadoPor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          label: "Flete OC",
                                          "prepend-icon": "local_shipping",
                                          disabled: !_vm.comprobarEdicionEquipos()
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.updateFlete()
                                          }
                                        },
                                        model: {
                                          value: _vm.flete,
                                          callback: function($$v) {
                                            _vm.flete = $$v
                                          },
                                          expression: "flete"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm3: "", md3: "" } },
                                    [
                                      _vm.esInternacional
                                        ? _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              label: "Tipo Cambio",
                                              "prepend-icon": "payments",
                                              disabled: !_vm.comprobarEdicionEquipos(),
                                              hint: "Para decimales usar coma"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.updateDolar()
                                              }
                                            },
                                            model: {
                                              value: _vm.precioDolar,
                                              callback: function($$v) {
                                                _vm.precioDolar = $$v
                                              },
                                              expression: "precioDolar"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-divider", { staticClass: "mt-3 mb-2" }),
                              _vm.comprobarEdicionEquipos()
                                ? _c(
                                    "FormFieldsContainer",
                                    [
                                      _c("h2", { staticClass: "ml-2" }, [
                                        _vm._v("Agregar Equipos")
                                      ]),
                                      _c("v-flex", {
                                        attrs: { sm10: "", md10: "" }
                                      }),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm3: "", md3: "" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              "item-text": "tipoeqname",
                                              items: _vm.alreadyReload
                                                ? _vm.newList
                                                : _vm.lista_equipos,
                                              "item-value": "tipoeqid",
                                              label: "Equipo (Requerido)",
                                              "prepend-icon":
                                                "home_repair_service",
                                              disabled: _vm.deshabilitado
                                            },
                                            model: {
                                              value: _vm.equipo,
                                              callback: function($$v) {
                                                _vm.equipo = $$v
                                              },
                                              expression: "equipo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm3: "", md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "prepend-icon":
                                                "production_quantity_limits",
                                              color: "primary",
                                              label: "Cantidad (Requerido)",
                                              type: "number",
                                              "hide-spin-buttons": "",
                                              disabled: _vm.deshabilitado
                                            },
                                            model: {
                                              value: _vm.cantidad,
                                              callback: function($$v) {
                                                _vm.cantidad = $$v
                                              },
                                              expression: "cantidad"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm3: "", md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "prepend-icon": "price_change",
                                              color: "primary",
                                              label:
                                                "Precio Unitario (Requerido)",
                                              "data-vv-name": "precio",
                                              type: "number",
                                              "hide-spin-buttons": "",
                                              disabled: _vm.deshabilitado,
                                              hint: "Para decimales usar coma"
                                            },
                                            model: {
                                              value: _vm.precio,
                                              callback: function($$v) {
                                                _vm.precio = $$v
                                              },
                                              expression: "precio"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            sm2: "",
                                            md2: "",
                                            "mt-2": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "btn-crear v-btn theme--light",
                                              on: {
                                                click: function($event) {
                                                  return _vm.addDevice()
                                                }
                                              }
                                            },
                                            [_vm._v("agregar")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "div",
                        { staticClass: "modalCrearOC" },
                        [
                          _vm.comprobarEdicionEquipos()
                            ? _c("MantenedorGridSinCodigo", {
                                staticClass: "ag-theme-material",
                                staticStyle: {
                                  width: "80%",
                                  height: "400px",
                                  "font-family": "'Asap' sans-serif"
                                },
                                attrs: {
                                  gridOptions: _vm.gridOptions,
                                  funcionalidadId: _vm.funcionalidad
                                }
                              })
                            : _c("MantenedorGrid", {
                                staticClass: "ag-theme-material",
                                staticStyle: {
                                  width: "80%",
                                  height: "400px",
                                  "font-family": "'Asap' sans-serif"
                                },
                                attrs: { gridOptions: _vm.gridOptions }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.mostrarModalCONFIRMAR,
          titulo: _vm.$t("Confirmación"),
          mensaje: _vm.Modal_confirmar_TEXTO,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.ModalConfirmarCreacion,
          titulo: _vm.$t("Confirmación"),
          mensaje: _vm.ModalConfirmarCreacion_TEXTO,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.crear($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }